import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../api/api";

export const Profile = () => {
  const navigate = useNavigate();
  const [locOn, setLocOn] = useState(false);
  const [touchOn, setTouchOn] = useState(false);

  const Row = ({ icon, title, sub, onClick, withChevron=true }) => (
    <button onClick={onClick} className="w-full text-left">
      <div className="px-4 py-3 flex items-center justify-between border-b border-[#eadfb7]">
        <div className="flex items-center gap-3">
          {icon}
          <div>
            <p className="font-semibold">{title}</p>
            {sub && <p className="text-[12px] text-[#5d4037]/80">{sub}</p>}
          </div>
        </div>
        {withChevron && (
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" stroke="#5d4037" strokeWidth="2" viewBox="0 0 24 24"><path d="M9 18l6-6-6-6"/></svg>
        )}
      </div>
    </button>
  );

  const ToggleRow = ({ icon, title, on, setOn }) => (
    <div className="px-4 py-3 flex items-center justify-between border-b border-[#eadfb7]">
      <div className="flex items-center gap-3">
        {icon}
        <p className="font-semibold">{title}</p>
      </div>
      <button
        onClick={() => setOn(!on)}
        className={`relative w-11 h-6 rounded-full transition-colors ${on ? "bg-[#5d4037]" : "bg-[#e8dcb7]"}`}
      >
        <span className={`absolute top-1 left-1 w-4 h-4 rounded-full bg-white transition-transform ${on ? "translate-x-5" : ""}`} />
      </button>
    </div>
  );

  return (
    <div className="min-h-screen grid place-items-center bg-[#fff8e1]">
      <div className="relative app-container [font-family:'Nunito',Helvetica] text-[#5d4037] pb-40">

        <div className="w-full flex items-center mt-4">
          <button onClick={() => navigate(-1)} className="ml-4 w-9 h-9 rounded-full bg-[#ccb357] grid place-items-center" aria-label="Back">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" stroke="#5d4037" strokeWidth="2" viewBox="0 0 24 24"><path d="M15 18l-6-6 6-6"/></svg>
          </button>
          <h1 className="flex-1 text-center font-bold text-[18px]">My Profile</h1>
          <div className="w-9" />
        </div>

     
        <div className="w-full flex justify-center mt-4">
          <div className="relative">
            <img alt="" className="w-[96px] h-[96px] rounded-full object-cover border-4 border-[#ccb357]"
                 src="https://cdn-icons-png.flaticon.com/512/149/149071.png" />
            <button className="absolute right-0 bottom-0 w-7 h-7 rounded-full bg-[#5d4037] grid place-items-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="#f7c945"><path d="M18 2l4 4-10 10H8v-4L18 2z"/></svg>
            </button>
          </div>
        </div>

        
        <div className="mt-6">
          <p className="px-4 text-[12px] font-extrabold uppercase">Profile</p>
          <Row
            title="Edit Profile"
            onClick={()=>navigate('/personal-info')}
            icon={<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="#5d4037"><path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25z"/><path d="M20.71 7.04a1.003 1.003 0 000-1.42l-2.34-2.34a1.003 1.003 0 00-1.42 0l-1.83 1.83 3.75 3.75 1.84-1.82z"/></svg>}
          />
          {/* <ToggleRow
            title="Turn on your location"
            on={locOn}
            setOn={setLocOn}
            icon={<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="#5d4037"><path d="M12 2C8 2 5 5 5 9c0 5 7 13 7 13s7-8 7-13c0-4-3-7-7-7zm0 9.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5z"/></svg>}
          /> */}

          <p className="px-4 mt-4 text-[12px] font-extrabold uppercase">Security</p>
          <Row
            title="Change password"
            onClick={()=>navigate('/forgot-password')}
            icon={<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="#5d4037"><path d="M7 11V7a5 5 0 0110 0v4"/><rect x="5" y="11" width="14" height="10" rx="2"/></svg>}
          />
          {/* <ToggleRow
            title="Sign in with touch ID"
            on={touchOn}
            setOn={setTouchOn}
            icon={<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="#5d4037"><path d="M12 12a5 5 0 00-5 5v3h10v-3a5 5 0 00-5-5z"/><path d="M12 11a3 3 0 003-3V7a3 3 0 10-6 0v1a3 3 0 003 3z"/></svg>}
          />

          <p className="px-4 mt-4 text-[12px] font-extrabold uppercase">Business Hours</p>
          <Row
            title="Operating Hours"
            sub="Mon-Sat: 8am - 6pm, Sun: Closed"
            onClick={() => console.log("Operating Hours")}
            icon={<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="#5d4037"><path d="M3 4h18v2H3z"/><path d="M8 2h8v2H8z"/><path d="M19 8H5v12h14z"/><path d="M12 12v4M8 12v4M16 12v4"/></svg>}
          />

          <p className="px-4 mt-4 text-[12px] font-extrabold uppercase">More</p>
          <Row
            title="Language"
            onClick={() => console.log("Language")}
            icon={<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="#5d4037"><path d="M12 3a9 9 0 100 18 9 9 0 000-18z"/><path d="M2 12h20M12 2a15 15 0 010 20M12 2a15 15 0 000 20"/></svg>}
          /> */}

        
          <button
          onClick={async () => {
                          try {
                            await api.auth.logout();
                          } catch (err) {
                            console.warn("Logout failed:", err);
                          } finally {
                            // Clear client data
                            localStorage.removeItem("sp_token");
                            localStorage.removeItem("sp_user");
                            localStorage.removeItem("sp_role");
                            localStorage.removeItem("sp_userId");
                            // Redirect to login
                            window.location.href = "/auth/login";
                          }
                        }}
           className="w-full">
            <div className="px-4 py-3 flex items-center gap-3 text-[#c34040]">
              <span>!</span>
              <span>Log Out</span>
            </div>
          </button>
        </div>

        {/* Bottom tabs */}
        <div className="fixed bottom-3 md:bottom-6 left-1/2 -translate-x-1/2 w-full max-w-[1440px] xl:max-w-[1600px] px-6 md:px-10 xl:px-16">
          <div className="px-6 pt-2 pb-4 bg-white border-t border-[#eadfb7]">
            <div className="grid grid-cols-4 gap-4 text-[12px] text-[#5d4037]">
              {/* Overview */}
              <div className="flex flex-col items-center" onClick={()=>navigate('/dashboard')}>
                <div className="w-9 h-9 rounded-[12px] bg-white border border-[#eadfb7] grid place-items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" stroke="#5d4037" strokeWidth="2" viewBox="0 0 24 24"><path d="M3 10.5L12 4l9 6.5"/><path d="M5 10v10h14V10"/></svg>
                </div>
                <span className="mt-1 text-[#5d4037]/80">Overview</span>
              </div>
              {/* Orders */}
              <div className="flex flex-col items-center" onClick={()=>navigate('/orders')}>
                <div className="w-9 h-9 rounded-[12px] bg-white border border-[#eadfb7] grid place-items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" stroke="#5d4037" strokeWidth="2" viewBox="0 0 24 24"><rect x="4" y="3" width="16" height="18" rx="2"/><path d="M8 7h8M8 11h6M8 15h8"/></svg>
                </div>
                <span className="mt-1 text-[#5d4037]/80">Orders</span>
              </div>
              {/* Products */}
              <div className="flex flex-col items-center" onClick={()=>navigate('/products')}>
                <div className="w-9 h-9 rounded-[12px] bg-white border border-[#eadfb7] grid place-items-center">
                  <div className="w-6 h-6 rounded-full border border-[#5d4037] grid place-items-center">
                    <span className="text-[11px] font-bold leading-none text-[#5d4037]">P</span>
                  </div>
                </div>
                <span className="mt-1 text-[#5d4037]/80">Products</span>
              </div>
              {/* Profile active */}
              <div className="flex flex-col items-center">
                <div className="w-9 h-9 rounded-[12px] bg-white border border-[#eadfb7] grid place-items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#5d4037" strokeWidth="2"><path d="M12 12a4 4 0 100-8 4 4 0 000 8z"/><path d="M20 21v-2a6 6 0 00-6-6H10a6 6 0 00-6 6v2"/></svg>
                </div>
                <span className="mt-1 font-semibold">Profile</span>
              </div>
            </div>
          </div>
          <div className="h-[22px] bg-[#5d4037] flex items-center justify-center">
            <div className="w-[120px] h-[6px] rounded-full bg-white"/>
          </div>
        </div>
      </div>
    </div>
  );
};
